<template>
    <div :class="{scrollableY: !editMode}" >
       <div :class="{container: !editMode}">
            <div v-if="editMode" class="is-inline-block cms-menu has-text-centered">
                <div class="cms-menu-element" :class="{isGrey: pageType == 3}" @click="switchTools(5)" v-tooltip="'Pages'"><i class="fa fa-file fa-2x" ></i></div>
                <div class="cms-menu-element" :class="{isGrey: pageType == 3}" @click="switchTools(1)" v-tooltip="'Sections'"><i class="fa fa-columns fa-2x"></i></div>
                <div class="cms-menu-element" :class="{isGrey: pageType == 3}" @click="switchTools(2)" v-tooltip="'Profiles'"><i class="fa fa-user fa-2x"></i></div>
                <div class="cms-menu-element" :class="{isGrey: pageType == 3}" @click="switchTools(3)" v-tooltip="'Bundles'"><i class="fa fa-grip-horizontal fa-2x"></i></div>
                <div class="cms-menu-element" :class="{isGrey: pageType == 3}" @click="switchTools(4)" v-tooltip="'Images'"><i class="fa fa-image fa-2x"></i></div>
                <div class="cms-menu-element" :class="{isGrey: pageType == 3}" @click="switchTools(6)" v-tooltip="'Ads'"><i class="fa fa-ad fa-2x"></i></div>
            </div>

            <div v-if="editMode" class="is-inline-block cms-tools">

                <div v-show="(currTools == 5)" class="toolSet top5">
                    <button class="cms-title is-small xs button" :class="{'is-coolGreen' : pageType == 1}" @click="togglePageType(1)">Discover</button>&nbsp;
                    <button class="cms-title is-small xs button" :class="{'is-coolGreen' : pageType == 2}" @click="togglePageType(2)">Help</button>&nbsp;
                    <button class="cms-title is-small xs button" :class="{'is-coolGreen' : pageType == 3}" @click="togglePageType(3)">Emails</button>
                    

                   <div v-show="this.pageType == 1" class="left10 top10">
                        <div v-for="(it, inde) in pages" :key="inde">
                            <div class="is-inline-block" ><span @click="selectPage(it.id, it.name, it.isLanding, it.code)" class="handCursor pageLabel"><b>{{it.name}}</b></span></div> 
                            &nbsp;<img src="@/assets/img/pencil.png" width="12" class="handCursor" @click="editPage(it, inde)"  />
                        </div>
                        <div class="newBundleBt top10 is-size-6" @click="newPage(0)"><b>+</b></div>
                   </div>

                   <div v-show="this.pageType == 2" class="left10 top10">

                            <helpTree
                                :item= tree[0] 
                                :depth=0
                                :inHelp=0
                                >
                            </helpTree>


                      <!--   <div v-for="(it, inde) in landingPages" :key="inde">
                            <div class="is-inline-block" ><span @click="selectPage(it.id, it.name, it.isLanding)" class="handCursor pageLabel"><b>{{it.name}}</b></span></div> 
                            &nbsp;<img src="@/assets/img/pencil.png" width="12" class="handCursor" @click="editPage(it, inde)"  />
                        </div> -->
                        <div class="newBundleBt top10 is-size-6" @click="newPage(1)"><b>+</b></div>
                   </div>

                   <div v-show="this.pageType == 3" class="left10 top10">

                     <div v-for="(it, eInd) in emails" :key="eInd">
                        <div class="is-inline-block" ><span @click="selectEmail(it.id, it.name)" class="handCursor pageLabel"><b>{{it.name}}</b></span></div> 
                     </div>
                       
                   </div>


                   <div></div>
                </div>
                
                
                <div v-show="currTools == 1" class="toolSet">
                   <div class="cms-title">Sections</div>
                   <div>
                        <div draggable class="layoutItem vTop" @drag="drag('titleSection')">
                            Title
                        </div>

                        <div class="layoutItem vTop" draggable  @drag="drag('subTitleSection')">
                            Subtitle
                        </div>

                        <div class="layoutItem vTop" draggable @drag="drag('paragraph')">
                            Freeform
                        </div>

                        <div class="layoutItem vTop" draggable  @drag="drag('threeColumns')">
                            <div class="has-text-centered">
                                <div style="display: inline-block; height: 56px; width: 30px; background-color: #aaa; margin-left: 2px; margin-right: 2px;">&nbsp;</div>
                                <div style="display: inline-block; height: 56px; width: 30px; background-color: #aaa; margin-left: 2px; margin-right: 2px">&nbsp;</div>
                                <div style="display: inline-block; height: 56px; width: 30px; background-color: #aaa; margin-left: 2px; margin-right: 2px">&nbsp;</div>
                            </div>
                        </div>

                        <div class="layoutItem vTop" draggable  @drag="drag('fourColumns')">
                            <div class="has-text-centered">
                                <div style="display: inline-block; height: 56px; width: 21px; background-color: #aaa; margin-left: 2px; margin-right: 2px;">&nbsp;</div>
                                <div style="display: inline-block; height: 56px; width: 21px; background-color: #aaa; margin-left: 2px; margin-right: 2px">&nbsp;</div>
                                <div style="display: inline-block; height: 56px; width: 21px; background-color: #aaa; margin-left: 2px; margin-right: 2px">&nbsp;</div>
                                <div style="display: inline-block; height: 56px; width: 21px; background-color: #aaa; margin-left: 2px; margin-right: 2px">&nbsp;</div>
                            </div>
                        </div>

                        <div class="layoutItem vTop" draggable  @drag="drag('imageAndText')">
                            <div class="has-text-centered">
                                <div style="display: inline-block; height: 56px; width: 40px; background-color: #aaa; margin-left: 2px; margin-right: 2px; vertical-align: top">&nbsp;</div>
                                <div style="display: inline-block; height: 56px; width: 40px; margin-left: 2px; margin-right: 2px;">
                                    <div class="is-size-7">Title</div>
                                    <div class="is-size-8 has-text-grey-light">Text</div>
                                </div>
                            </div>
                        </div>

                        <div class="layoutItem vTop" draggable  @drag="drag('landingHeader', true)">
                            <div class="has-text-centered top10">
                                <div style="display: inline-block; height: 56px; width: 40px;  margin-right: 2px;">
                                    <div class="is-size-7">Title</div>
                                    <div class="is-size-8 has-text-grey-light">Text</div>
                                </div>
                                <div style="display: inline-block; height: 30px; width: 30px; background-color: #aaa; margin-left: 2px; margin-right: 2px; vertical-align: top">Ad</div>
                            </div>
                        </div>

                        <div class="layoutItem vTop" draggable @drag="drag('divider1')">
                            <div style="border-bottom: 2px dotted #f1c232; margin-top: 25px"></div>
                        </div>

                       <!--  <div class="layoutItem vTop" draggable  @drag="drag('threeAds')">
                            <div class="has-text-centered">
                                <div style="display: inline-block; height: 30px; width: 30px; background-color: #aaa; margin-left: 2px; margin-right: 2px;">&nbsp;</div>
                                <div style="display: inline-block; height: 30px; width: 30px; background-color: #aaa; margin-left: 2px; margin-right: 2px">&nbsp;</div>
                                <div style="display: inline-block; height: 30px; width: 30px; background-color: #aaa; margin-left: 2px; margin-right: 2px">&nbsp;</div>
                                <div>ads</div>
                            </div>
                        </div> -->

                        <div class="layoutItem vTop" draggable  @drag="drag('bundleComplete')">
                            <div class="has-text-centered">
                                <div class="top5" style="display: inline-block; height: 20px; width: 99px; background-color: #aaa; margin-left: 2px; margin-right: 2px;">&nbsp;</div>
                                <div>bundle</div>
                            </div>
                        </div>

                        <div class="layoutItem vTop" draggable  @drag="drag('faqSection')">
                            FAQ
                        </div>
                   </div>
                </div>


                <div v-show="currTools == 2" class="toolSet">
                    <div class="cms-title">Profiles</div>

                    <div class="top20 bottom20">
                        <input class="input searchTextInput" type="text" placeholder="search profiles" style="width: 200px" v-model="profileTerms"  @keyup.enter="searchProfiles(true)"/>
                        <button class="button is-coolGreen is-small left-10 has-text-grey" style="z-index: 1" @click="searchProfiles(true)"><i class="fa fa-search"></i></button>
                    </div>

                    <div draggable class="top10" v-for="(p, pi) in ptn" :key="pi" @drag="objDrag({type: 'profile', img: p.avatarImg, handle: p.handle})">
                        <div><img class="avatar pointerEventsOff" :src="p.avatarImg" width="30" />
                        <b style="position: relative; top: -10px; left: 5px">{{p.handle}}</b></div>
                    </div>
                    <div v-show="ptn.length" class="top10 handCursor" @click="searchProfiles(false)">show more</div>

                </div>



                <div v-show="currTools == 3" class="toolSet">
                    <div class="cms-title">Bundles</div>
                   <div class="scrollableY">

                    <div class="top20">
                        <input class="input searchTextInput" type="text" placeholder="search public bundles" style="width: 200px" v-model="bundleTerms"  @keyup.enter="searchBundles(true)"/>
                        <button class="button is-coolGreen is-small left-10 has-text-grey" style="z-index: 1" @click="searchBundles(true)"><i class="fa fa-search"></i></button>
                    </div>


                        <div draggable class="top10" v-for="(b, bi) in btn" :key="bi" @drag="objDrag({type: 'bundle', bund: b})">
                            <!-- <div><img class="avatar pointerEventsOff" :src="b.avatarImg" width="30" /> -->
                                <div class="is-inline-block has-text-coolGreen handCursor is-size-5 " >&nbsp;<b>::</b></div><b style="left: 5px"> {{b.listName}} - {{b.handle}}</b>
                        </div>

                        <div v-show="btn.length" class="top10 handCursor" @click="searchBundles(false)">show more</div>


                   </div>
                </div>

                <div v-show="currTools == 4" class="toolSet" >
                    <div class="cms-title">Images</div>
                    <div class="top10">
                        <div v-for="(it, ind) in images" class="is-inline-block cms-img" style="max-height: 80px"  @click="enlarge(it.img)">
                            <img draggable :src="it.img" width="80"  @drag="objDrag({type: 'img', img: it.img})" />
                        </div>
                        <div v-show="images.length" class="top10 handCursor" @click="searchBundles(false)">show more</div>
                    </div>
                </div>

                <div v-show="currTools == 6" class="toolSet" >
                    <div class="cms-title">Ads</div>
                    <div class="top10">
                        
                        <div draggable class="cmsAdtn" @drag="objDrag({type: 'ad'})">
                            Ad Unit
                        </div>
                        
                    </div>
                </div>

            
            </div>

            <!---BODY--->
            <div class="is-inline-block cms-body" :class="{removeWidth: !editMode, removeScroll: !editMode}">
                
             <div  class="has-background-dark pad10" :class="{'noBG': !editMode}">
                    <div v-if="editMode" class="has-text-white is-size-4 right10 ">{{currName}}</div>
                    <div  v-if="(editMode  && currentId) && pageType != 3" class="is-pulled-left  is-size-6 has-text-light right10 ">https://{{appDomainName}}/{{isLanding ? 'accsettings/help' : 'discover'}}/{{currentId}}</div>
                    <div v-show="pageType != 3 && editMode" class="has-text-light">
                        <div><b>OR</b></div>
                        <div>https://{{appDomainName}}/{{isLanding ? 'accsettings/help' : 'discover'}}/{{currSlug ? currSlug : '[slug] (do not use unless slug is set)'}}</div>
                    </div>
                    <div v-if="pageType == 3" class="has-text-white">{{currentDesc}}</div>
                    <div class="has-text-right bottom10" v-show="editMode">
                        <button v-show="pageType != 3" id="liveButt"  class="button is-dark" :class="{'is-coolGreen': isLive}" @click="toggleLive">LIVE</button>&nbsp;
                        <button  v-show="pageType != 3" class="button" @click="toggleEdit" :class="{'is-coolGreen' : !editMode, 'is-dark' : editMode, 'exitButtonAdj' : !editMode}">{{editMode ? 'PREVIEW' : 'EXIT'}}</button>&nbsp;
                        <button  id="saveButt"  class="button" @click="saveDelegate" :class="{'is-dark' : !pageChanged, 'is-coolGreen': pageChanged}">SAVE</button>
                    </div>
                    <div v-show="!editMode" class="cmsExitBtn button is-small xs" @click="toggleEdit">EDIT</div>
             </div>

               <div class="top20" :class="{editMode: 'top80'}">
                    <div   v-for="(item, i) in source" :key="i">
                        <component ref="thecomp" :is="item.comp" :params="item.params" :index="i" :isDragged="item.isDragged"></component>
                    </div>
               </div>


                <dropper v-show="(editMode && currentId)" class="top10" :level="1" :index="(source.length || 0)"></dropper>
               
            </div>
            <div v-if="!isLanding"><br/> <br/> <br/></div>
       </div>
      
       
    </div>
</template>


<script>


import titleSection from '../components/cms/titleSection.vue'
import subTitleSection from '../components/cms/subTitleSection.vue'
import bundleComplete from '../components/cms/bundleComplete.vue'
import threeColumns from '../components/cms/threeColumns.vue'
import fourColumns from '../components/cms/fourColumns.vue'
import paragraph from '../components/cms/paragraph.vue'
import cmsFooter from '../components/cms/cmsFooter.vue'
import faq from '../components/cms/cmsFaq.vue'
import landingHeader from '../components/cms/landingHeader.vue'
import helpTree from '../components/helpTree.vue'
import threeAds from '../components/cms/threeAds.vue'
import imageAndText from '../components/cms/imageAndText.vue'
import divider1 from '../components/cms/divider1.vue'
import dropper from '../components/cms/sectionDropper.vue'
import { AZEventBus } from '../components/AZEventBus'

export default {
    components: {titleSection, dropper, subTitleSection, threeColumns, paragraph, imageAndText, divider1, fourColumns, threeAds, landingHeader, bundleComplete, cmsFooter, helpTree, faq},
    data: function(){
        return {
            tree: [{name: ''}],
            pageType: 1,
            inited: false,
            editMode: true,
            currTools: 5,
            source: [],
            dataTransfer: {},
            isLanding: false,
            bundleTerms: '',
            profileTerms: '',
            profileOffset: 0,
            bundlesOffset: 0,
            imagesOffset: 0,
            defaults: {
                titleSection: {comp: 'titleSection', params: {title: 'Section Title'}, type: 'section'},
                subTitleSection: {comp: 'subTitleSection', params: {subtitle: 'Subtitle'}, type: 'section'},
                threeColumns: {comp: 'threeColumns', params: {}, type: 'section',
                    params: {cols: 
                        [
                            {img: '', tgt: '', type: '', handle: '', bund: {}, text: ''},
                            {img: '', tgt: '', type: '', handle: '', bund: {}, text: ''},
                            {img: '', tgt: '', type: '', handle: '', bund: {}, text: ''}
                        ]
                    }
                },
                fourColumns: {comp: 'fourColumns', params: {}, type: 'section',
                    params: {cols: 
                        [
                            {img: '', tgt: '', type: '', handle: '', bund: {}, text: ''},
                            {img: '', tgt: '', type: '', handle: '', bund: {}, text: ''},
                            {img: '', tgt: '', type: '', handle: '', bund: {}, text: ''},
                            {img: '', tgt: '', type: '', handle: '', bund: {}, text: ''}
                        ]
                    }
                },
                paragraph: {comp: 'paragraph', params: {text: '<p>Freeform Space</p>'}, type: 'section'},
                imageAndText: {comp: 'imageAndText', params: {img: '',  text: '<h1><strong>Section Title</strong></h1><p>Paragraph text</p>', cols: [ {img: '', tgt: '', type: 'img', handle: '', bund: {}, text: ''}]}, type: 'section'},

                landingHeader: {comp: 'landingHeader', params: {img: '', title: 'Title', text: '<h2>Subheading or paragraph text</h2>', cols: [{img: '', tgt: '', type: 'img', handle: '', bund: {}, text: ''}]}, type: 'section'},


                bundleComplete: {comp: 'bundleComplete', params: {img: '', bund: {}, type: 'bundle'}, type: 'section'},

                divider1: {comp: 'divider1', params: {}, type: 'section'},
                threeAds: {comp: 'threeAds', params: {}, type: 'section'},
                faqSection: {comp: 'faq', params: {faqs:[{q: 'a', a: 'b'}]}, type: 'section'},
                footer: {comp: 'footer', params: {}, type: 'section'}
            },
            images: [],
            ptn: [],
            btn: [],
            pages: [],
            landingPages: [],
            pageChanged: false,
            currentId: '',
            currName: '',
            currentDesc: '',
            appDomainName: process.env.VUE_APP_DOMAIN_NAME,
            isLive: true,
            slug: '',
            helpPages: [],
            emails: [],
            currSlug: ''
            
        }
    },

   

    mounted: function() {

        
        var self = this;

        AZEventBus.$on('pageChanged', this.pageChangedHandler)

        AZEventBus.$on('CMSpageNavigation', this.CMSpageNavigationHandler)
      

        function init(){
            
            self.loadPages()
            self.loadEmails()
            //self.searchBundles() //temporary until actual search is implemented
            
        }

        if(self.$root.app.doneFederating){
            init();
        }

        AZEventBus.$once('onFederate', msg => {
            init();
        });

        AZEventBus.$on('pageSelected', this.pageSelectedHandler);

    },

    beforeDestroy: function(){
        AZEventBus.$off('pageChanged', this.pageChangedHandler)

        AZEventBus.$off('CMSpageNavigation', this.CMSpageNavigationHandler)

        AZEventBus.$off('pageSelected', this.pageSelectedHandler);

    },



    methods: {

        pageChangedHandler: function(mgs){
            this.pageChanged = true
        },

        CMSpageNavigationHandler: function(msg){
            this.selectPage(msg.id, msg.name, msg.isLanding, msg.code)
        },

        pageSelectedHandler: function(msg){
            this.selectPage(msg.id, msg.name, msg.isLanding, msg.code)
        },

        enlarge: function(img){
            this.$root.app.doShowModal('ModalLightbox', {message: img})
        },

        loadPages: function(){

            var self = this;

            function w2(d){
                self.pages = d.pages.filter(e => {
                    return !e.isLanding
                })

                self.landingPages =  d.pages.filter(e => {
                    return e.isLanding
                    })
                
                if(self.pages.length){
                    self.selectPage(self.pages[0].id, self.pages[0].name, self.pages[0].code)
                } else {
                    this.newPage()
                }
            
                self.landingPages.forEach(e => {
                    if(e.children)
                        e.children = e.children.split(',')
                    else
                        e.children = []
                    
                })

                self.buildTree(self.landingPages)
            }

            function n2(){

            }

            self.$root.app.apiClient.get('subs/data/pages', {}, w2, n2)
    

        },

        loadEmails: function(){
            var self = this;

            function w2(d){
                self.emails = d.emails
               

            }

            function n2(){

            }

            self.$root.app.apiClient.get('subs/data/emails', {}, w2, n2)
        },

        switchTools: function(val){

            if(this.pageType == 3){
                return
            }

            this.currTools = val

            var self = this

            if(val == 4){

                this.images = []
                this.imagesOffset = 0

                function w(d){
                    self.images = d
                    self.imagesOffset += 20
                }

                function n(){

                }

                this.$root.app.apiClient.get('subs/data/cmsimages/' + this.imagesOffset, {}, w, n)
            }
        },

        dragOver: function() {
          
        },

        drag: function (val, isDragged) {
          this.dataTransfer = this.defaults[val]
          this.dataTransfer.isDragged = isDragged  //to send prop to landinHeader telling it is was dragged in instad of part of Landing Page.
        },

        objDrag: function (obj) {
            if(obj.type == 'img'){
                this.dataTransfer = {img: obj.img, type: "img", text: ''}
            } else if(obj.type == 'profile'){
                this.dataTransfer = {img: obj.img, handle: obj.handle, type: "profile"}
            } else if(obj.type == 'bundle'){
                this.dataTransfer = {bund: obj.bund, type: "bundle"}
            } else if(obj.type == 'ad'){
                this.dataTransfer = {bund: {}, type: "ad"}
            }
            
        },

        drop: function(i) {
            var self = this
            if(i == this.source.length || 0){
                this.source.push(JSON.parse(JSON.stringify(this.dataTransfer)))
            } else {
                this.source.splice(i, 0, JSON.parse(JSON.stringify(this.dataTransfer)))
            }
            AZEventBus.$emit('pageChanged', null)
            this.dataTransfer = {}
            
        },

        toggleEdit: function(){
            this.editMode = !this.editMode
        },


        saveDelegate: function(){
            if(this.pageType == 3){
                this.saveEmail()
            } else {
                this.save()
            }
        },


        save: function(){
            var self = this

            function w(d){
                az.addRemSpinner(false, 'id', 'saveButt')
                self.pageChanged = false
            }

            function n(){
                az.addRemSpinner(false, 'id', 'saveButt')
            }
            az.addRemSpinner(true, 'id', 'saveButt')
            this.$root.app.apiClient.put('subs/data/pagecontent', {source: JSON.stringify(this.source), id: this.currentId}, w, n)
        },


        saveEmail: function(){
            var self = this

            function w(d){
                az.addRemSpinner(false, 'id', 'saveButt')
                self.pageChanged = false
            }

            function n(){
                az.addRemSpinner(false, 'id', 'saveButt')
            }
            az.addRemSpinner(true, 'id', 'saveButt')
            this.$root.app.apiClient.put('subs/data/emailcontent', {source: JSON.stringify(this.source), id: this.currentId}, w, n)
        },

        newPage: function(val, ){
            this.$root.app.doShowModal('modalNewPage', {isLanding: val, tree: this.tree})
        },


        searchProfiles: function(clearIt){

            var self = this;

            if(clearIt){
                self.ptn = []
                self.profilesOffset = 0
            } else {
                self.profilesOffset += 20
            }

            function w(d){
                self.ptn = self.ptn.concat(d.results)
                
            }

            function n(){

            }

            this.$root.app.apiClient.post('subs/data/profilesearch', {terms: this.profileTerms, limit: 20, offset: this.profilesOffset}, w, n)


        },

        searchBundles: function(clearIt){
            var self = this

            if(clearIt){
                self.btn = []
                self.bundlesOffset = 0
            } else {
                self.bundlesOffset += 20
            }

            function w(d){
                var temp = []
                d.publicBundles.forEach(e => {
                    if(!temp.includes(e.handle) && e.handle != 'sofia'){
                        //self.ptn.push(e)
                        temp.push(e.handle)
                    }
                })

                d.publicBundles.forEach(e => {
                    var arr = d.cards.filter(i => {
                        return i.id_BUNDLES == e.id_BUNDLES
                    })
                    if(arr[0] == undefined)
                        arr[0] = {img: 'asdfa'}
                    if(arr[1] == undefined)
                        arr[1] = {img: 'asdfa'}
                    if(arr[2] == undefined)
                        arr[2] = {img: 'asdfa'}

                    var temp = {
                        id: e.id_BUNDLES,
                        descr: e.pubNote,
                        dateModified: e.dateModified,
                        listName: e.listName,
                        handle: e.handle,
                        avatarImg: e.avatarImg,
                        imgs: arr,
                        mCode: e.mCode,
                        p: e.p,
                        pubId: e.pubId,
                        fid: e.fid,
                        fState: e.fState,
                        lastUpdate: e.lastUpdate
                    }
                    self.btn.push(temp)
                    })
            }

            function n(){

            }

            if(this.bundleTerms)
                self.$root.app.apiClient.post('subs/data/allpublic', {terms: this.bundleTerms, offset: this.bundlesOffset}, w, n)


        },

     /*    addPage: function(obj){

         
            if(!obj.isLanding){
                this.pages.push({name: obj.name, id: obj.id, isLanding: obj.isLanding})
                this.isLanding = false;
            } else {
                this.landingPages.push({name: obj.name, id: obj.id, isLanding: obj.isLanding})
                this.isLanding = true;
            }
            
            this.currentId = obj.id
            this.currName = obj.name
            if(!obj.isLanding){
                this.source = []
            } else {
                this.source = [
                                {
                                    comp: "landingHeader",
                                    type: "section",
                                    index: 0,
                                    params: {
                                    img: "",
                                    bund: {},
                                    cols: [
                                        {
                                        img: "",
                                        tgt: "",
                                        bund: {},
                                        type: "img",
                                        handle: ""
                                        }
                                    ],
                                    text: "Lorem ipsum dolor...",
                                    title: "Title"
                                    }
                                },
                                {
                                    comp: "bundleComplete",
                                    params: {
                                    img: "",
                                    bund: {},
                                    type: "bundle"
                                    },
                                    type: "section"
                                }
                            ]
            }
            
            this.pageChanged = false

        }, */



        selectPage: function(id, name, isLanding, slug){
           
            var self = this
            function w(d){
                self.source = []
                self.$nextTick(function () {
                    self.source = JSON.parse(d.source)
                    self.isLive = d.isLive 
                    self.currentId = id
                    self.currName = name
                    self.currSlug = slug
                    self.isLanding = isLanding
                })
               
            }

            function n(){

            }

            this.$root.app.apiClient.get('open/confirm/onepage/' + id, {}, w, n)
        },

        selectEmail: function(id, name){
           
           var self = this
           function w(d){
               self.source = []
               self.$nextTick(function () {
                   self.source = JSON.parse(d.source)
                   self.currName = name
                   self.currentId = id
                   self.currentDesc = d.description
               })
              
           }

           function n(){

           }

           this.$root.app.apiClient.get('subs/data/oneemail/' + id, {}, w, n)
       },

        

        editPage: function(obj, index){
            
            var isLanding = obj.isLanding;
            this.$root.app.doShowModal('modalNewPage', {createOrEdit: 'edit', item: obj, isLanding: isLanding, index: index, slug: this.slug, pageType: this.pageType})
        },

        togglePageType: function(val){
            this.pageType = val
            if(val == 3){   //emails
                this.selectEmail(this.emails[0].id, this.emails[0].name)
            }
        },

        updateName: function(obj){
           
            var arrToEdit = obj.isLanding ? this.landingPages : this.pages
            if(obj.index > -1){
                arrToEdit[obj.index].name = obj.name
            } else {
                
                var tgt = arrToEdit.find(e => {
                    return parseInt(e.id) == parseInt(obj.id)
                })
                tgt.name = obj.name
            }
        },  

        deletePage: function(index, isLanding){
            var arrToEdit = isLanding ? this.landingPages : this.pages
            arrToEdit.splice(index, 1)
            this.currentId = false
            this.currName = ''
            this.source = []
        },

        removeSection: function(index){
            this.source.splice(index, 1)
            this.pageChanged = true
        },

        toggleLive: function(){
            var live
            var self = this
            function w(d){
                az.addRemSpinner(false, 'id', 'liveButt')
                self.isLive = d.live
            }

            function n(){
                az.addRemSpinner(false, 'id', 'liveButt')
            }

            if(this.isLive){
                live = 0
            } else {
                live = 1
            }

            az.addRemSpinner(true, 'id', 'liveButt')
            this.$root.app.apiClient.put('subs/data/live', {id: this.currentId, live: live}, w, n)

        },

        buildTree: function(o){
            
            console.log('arr')

            var self = this;
            self.tree = []
            var arr= []

         

            function getChildren(ids){
                var ret = []
                
                for(var i=0; i < ids.length; i++){

                    //if id is not in bundles array, continue
                    
                        ret.push(o.find(function(e){
                            
                            if(parseInt(e.id) == parseInt(ids[i])){
                              
                                e.processed = true
                                
                                if(e.children.length){
                                    e.children = getChildren(e.children)
                                }
                               
                                return true
                            }                           
                        })
                    )
                    
                }
               
                return ret
            }

           

            o.forEach(e => {
                
                if(!e.processed){
                   e.children = getChildren(e.children)
                   arr.push(e)
                }
            })
            
       

            self.tree = arr
            
            

        }

    }

}

</script>

<style lang="sass" scoped>

    .avatar
        border-radius: 10px
        border: 3px solid #ccc

</style>